module.exports = __webpack_public_path__ + "img/kiss.7e199dd3.png";